export default {
	'report-raw-material-difference': {
		id: 'report-raw-material-difference',
		label: '原料分差分析表',
		code: '0008_0007'
	}
}
